import $ from 'jquery'

import form from '../../edit/form/form'

import documentInsert from '../../lib/documentInsert'
import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

import authReset from '../../lib/authReset'
import authSendWelcomeMail from '../../lib/authSendWelcomeMail'

export function getName(){
  return 'archive/users'
}

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var columns = [
    {
      id: 'firstName',
      value: item.firstName,
      type: o.type.text,
    },
    {
      id: 'lastName',
      value: item.lastName,
      type: o.type.text,
    },
    {
      id: 'organisation',
      value: item.organisation,
      type: o.type.text,
    },
    {
      id: 'project',
      value: item.project,
      type: o.type.text,
    },
    {
      id: 'phone',
      value: item.phone,
      type: o.type.text,
    },
    {
      id: 'email',
      value: item.email,
      type: o.type.text,
    },
    {
      id: 'role',
      value: item.role,
      type: o.type.text,
    },
    {
      id: 'lang',
      value: item.lang,
      type: o.type.text,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      table: {
        width: 300,
        multiline: true,
      },
    },
    {
      id: 'resetPassword',
      value: 'resetPassword',
      type: o.type.action,
      click: function(e){

        e.stopPropagation()

        var email = item.email
        var lang = item.lang

        authReset(o, email, lang, true, function(error){
          if(error){
            alert('an error occured')
            return
          }
        })

      }
    },
    {
      id: 'sendWelcomeMail',
      value: 'sendWelcomeMail',
      type: o.type.action,
      click: function(e){

        e.stopPropagation()

        var email = item.email
        var firstName = item.firstName
        var lastName = item.lastName
        var lang = item.lang

        authSendWelcomeMail(o,email,firstName,lastName,lang,function(error){
          if(error){
            alert('an error occured')
            return
          }
        })

      }
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.users,

      function(item){

        var model = o.model.aUsers
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            o.edit.set(item,model)
          }

        return {

          columns: columns,
          click: click,

        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  var fields = [
    {
      id: 'firstName',
      value: item.firstName,
      type: 'text',
      edit: true,
    },
    {
      id: 'lastName',
      value: item.lastName,
      type: 'text',
      edit: true,
    },
    {
      id: 'organisation',
      value: item.organisation,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'project',
      value: item.project,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'phone',
      value: item.phone,
      type: 'text',
      edit: true,
      optional: true,
    },
    {
      id: 'email',
      value: item.email,
      type: 'text',
      edit: true,
    },
    {
      id: 'role',
      value: item.role,
      type: 'text',
      edit: true,
    },
    {
      id: 'lang',
      value: item.lang,
      type: 'text',
      edit: true,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      edit: true,
      optional: true,
    },
  ]

  return fields

}

export function insertForm(o,done){

}

export function remove(o,id,done){

  var data = o.data.users
  var collection = 'users'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

  var data = o.data.users
  var collection = 'users'

  item.user = o.store('email')
  item.date = new Date()

  documentInsert(o,data,item,collection)

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.users
  var collection = 'users'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'date',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aUsers/aUsers.js